import React, { useState } from 'react';
import { connect } from 'react-redux';
import Valg, { DisplayValue } from '../../Shared/Scripts/Models/Valg';
import VeilederStegComponent, { VeilederStegDefaultProps, VeilederStegBaseProps } from '../../Shared/Scripts/Components/VeilederStegComponent';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import ForelopigUttalelseSkjemaSideDto from '../Models/ForelopigUttalelseSkjemaSideDto';
import { ForelopigUttalelseSkjemaSideAppState } from '../Store';
import contentResolver from '../../Shared/Scripts/Utilities/EpiContentResolver';
import { setCollapsed } from '../../Shared/Scripts/Store/StegVisning/Actions';
import { StegVisning } from '../../Shared/Scripts/Store/StegVisning/Types';
import SelectOptionDisplay from '../../Shared/Scripts/Components/SelectOptionComponent';
import * as ValgTypes from '../Store/Valg/Types';
import { LegendWithErrorComponent } from '../../Shared/Scripts/Components/LegendWithErrorComponent';
import { focusInputElementOnError } from '../util/input-focus';

type Steg4aComponentOwnProps = VeilederStegDefaultProps & VeilederStegBaseProps & {
    ledetekst: JSX.Element | null,
    onChange: any,
    value?: Valg<ValgTypes.Periode>,
}

type Steg4aDisplayProps = Steg4aComponentOwnProps & MapStateToProps & MapDispatchToProps;

const FEILMELDING_PERIODE_ID = 'feilmelding-periode';

function Steg4aComponentVisning(props: Steg4aDisplayProps): JSX.Element {
    const { epiContext } = props;
    const [inputFra, setInputFra] = useState<Valg<string>>();
    const [inputTil, setInputTil] = useState<Valg<string>>();
    const [isInErrorState, setIsInErrorState] = useState<boolean>(false);


    function hentDato(valgt: Valg<string> | undefined): Date {
        let tmpValgt: string = '';
        if(valgt !== undefined && valgt !== null)
            tmpValgt = valgt.id;

        const dato: Date = new Date(tmpValgt);
        return dato;
    }

    function hentAarValg(valgt: Valg<string> | undefined): string {
        const fraAarDato: Date = hentDato(valgt); 
        const fraAar: string = fraAarDato.getFullYear()+'';

        return fraAar;
    }

    function hentMaanedValg(valgt: Valg<string> | undefined): string {
        const monthDato: Date = hentDato(valgt);
        const month: number = monthDato.getMonth() + 1;

        return month+'';
    }

    function hentSemesterValg(valgt: Valg<string> | undefined): string {
        let tmpInput: string = '';
        if(valgt !== undefined && valgt !== null)
            tmpInput = valgt.id;

        const dato: Date = new Date(tmpInput);
        
        if(epiContext.epiModel?.steg4LedetekstValgHost === undefined)
            return '';

        if(dato.getMonth() + 1 === 8)
            return epiContext.epiModel?.steg4LedetekstValgHost.value;

        if(dato.getMonth() + 1 === 1)
            return epiContext.epiModel?.steg4LedetekstValgVaar.value

        return '';
    }

    function buttonClickHandler(e: React.SyntheticEvent<HTMLButtonElement>): void {
        e.preventDefault();

        if(!validateForm()) {
            return;
        }
        
        props.stegVisningSetCollapsed({id: props.sporsmalId,isCollapsed:true});

        const aarFra: string = hentAarValg(inputFra);
        const aarTil: string = hentAarValg(inputTil);
        const semesterFra: string = hentSemesterValg(inputFra);
        const semesterTil: string = hentSemesterValg(inputTil);

        let valgte: Valg<ValgTypes.Periode> = { id:'periode', displayValue: semesterFra + ' ' + aarFra + ' - ' + semesterTil + ' ' + aarTil, value: { fraAar: aarFra, fraMaaned: hentMaanedValg(inputFra), tilAar: aarTil, tilMaaned: hentMaanedValg(inputTil) } }
        props.onChange(valgte);
    }

    function onSelectFraHandling(nyttFraValg: Valg<string>) {
        skjulDatoFeilmelding();
        setInputFra(nyttFraValg);
    }
    function onSelectTilHandling(nyttTilValg: Valg<string>) {
        skjulDatoFeilmelding();
        setInputTil(nyttTilValg);
    }

    function validateForm(): boolean {
        if(inputTil === undefined || inputFra === undefined) {
            visDatoFeilmelding();
            return false;
        }

        let fra = hentDato(inputFra);
        let til = hentDato(inputTil);

        if(til >= fra) {
            skjulDatoFeilmelding();
            return true;            
        }
        visDatoFeilmelding();    
        return false;
    }

    function hentFraValg(): DisplayValue[] {

        let fraValg: DisplayValue[] = [];

        const idag = new Date();
        const dagensMaaned: number = idag.getMonth() + 1;
        const dagensAar: number = idag.getFullYear();

        let host: string | undefined = epiContext.epiModel?.steg4LedetekstValgHost?.value;
        if(host === undefined)
            host = "Autumn"; //fallback

        let vaar: string | undefined = epiContext.epiModel?.steg4LedetekstValgVaar?.value;
        if(vaar === undefined)
            vaar = "Spring"; //fallback

        if(dagensMaaned < 6) {
            fraValg.push({id: dagensAar+'-01-01', displayValue: vaar + ' ' + dagensAar});
            fraValg.push({id: dagensAar+'-08-01', displayValue: host + ' ' + dagensAar});
        } else {
            fraValg.push({id: dagensAar+'-08-01', displayValue: host + ' ' + dagensAar});
        } 

        const antallAar: number = 3;
        for(let i = 1;i<antallAar;i++) {
            
            if(fraValg.length==3) {
                continue;
            }
            fraValg.push({id: (dagensAar + i)+'-01-01', displayValue: vaar + ' ' + (dagensAar + i)});

            if(fraValg.length==3) {
                continue;
            }
            fraValg.push({id: (dagensAar + i)+'-08-01', displayValue: host + ' ' + (dagensAar + i)});
        }

        return fraValg;
    }

    function hentTilValg(): DisplayValue[] {

        let fraValg: DisplayValue[] = [];

        let host: string | undefined = epiContext.epiModel?.steg4LedetekstValgHost?.value;
        if(host === undefined)
            host = "Autumn"; //fallback

        let vaar: string | undefined = epiContext.epiModel?.steg4LedetekstValgVaar?.value;
        if(vaar === undefined)
            vaar = "Spring"; //fallback

        const idag = new Date();
        const dagensAar: number = idag.getFullYear();
        const dagensMaaned: number = idag.getMonth() + 1;

        if(dagensMaaned < 6) {
            fraValg.push({id: dagensAar+'-01-01', displayValue: vaar + ' ' + dagensAar});
            fraValg.push({id: dagensAar+'-08-01', displayValue: host + ' ' + dagensAar});
        } else {
            fraValg.push({id: dagensAar+'-08-01', displayValue: host + ' ' + dagensAar});
        }

        const antallAar: number = 8;
        for(let i = 1;i<=antallAar;i++) {
            if(fraValg.length==15) {
                continue;
            }
            fraValg.push({id: (dagensAar + i)+'-01-01', displayValue: vaar + ' ' + (dagensAar + i)});

            if(fraValg.length==15) {
                continue;
            }
            fraValg.push({id: (dagensAar + i)+'-08-01', displayValue: host + ' ' + (dagensAar + i)});
        }

        return fraValg;
    }

    function visDatoFeilmelding(): void {
        setIsInErrorState(true);
        focusInputElementOnError({ id: 'js-veileder__fratilDato_feilmelding', errorClass: 'c-text-input--feil' });
    }

    function skjulDatoFeilmelding(): void {
        setIsInErrorState(false);
        let cont = document.getElementById("js-veileder__fratilDato_feilmelding");
        cont?.classList.remove("c-text-input--feil");

    }

    return (
        <VeilederStegComponent
            tittel={props.tittel}
            forklaring={props.forklaring}
            canCollapse={props.value != null}
            displayElement={<div className="c-veileder__valgt-item">
                <span className="c-veileder__tekst c-veileder__tekst--valg">{props.value?.displayValue}</span>
            </div>}
            inputArea={
                <div className="c-veileder__inputomrade">
                    <div className="c-veileder__inputomrade c-veileder__paddingTopBlanker c-veileder__inputomrade-med-sosken c-select-options-small c-select-options__label-override" id="js-veileder__fratilDato_feilmelding">                        
                        <fieldset className="c-veileder__fieldset">
                            <LegendWithErrorComponent
                                feilMeldingsId={FEILMELDING_PERIODE_ID}
                                showError={isInErrorState}
                                errorElement={contentResolver(epiContext, 'steg4FeilMedDato')}
                            >
                                {props.ledetekst}
                            </LegendWithErrorComponent>
                            <div className="c-veileder__inputomrade c-veileder__paddingTopBlanker c-veileder__inputomrade-med-sosken" >
                                <SelectOptionDisplay
                                    htmlId={props.sporsmalId + '-fra-select'}
                                    ledetekst={contentResolver(epiContext, 'steg4LedetekstFra')}
                                    options={hentFraValg()}
                                    onSelectChange={(nyttFraValg: Valg<string>): void => {
                                        onSelectFraHandling(nyttFraValg);
                                    }}
                                    buttonProps={{ 'aria-describedby': FEILMELDING_PERIODE_ID }}
                                    showSearch={false}
                                    value={inputFra}
                                />
                            </div>
                            <div className="c-veileder__inputomrade c-veileder__inputomrade-med-sosken">
                                <SelectOptionDisplay
                                    htmlId={props.sporsmalId + '-til-select'}
                                    ledetekst={contentResolver(epiContext, 'steg4LedetekstTil')}
                                    options={hentTilValg()}
                                    onSelectChange={(nyttTilValg: Valg<string>): void => {
                                        onSelectTilHandling(nyttTilValg);
                                    }}
                                    buttonProps={{ 'aria-describedby': FEILMELDING_PERIODE_ID }}
                                    showSearch={false}
                                    value={inputTil}
                                />
                            </div>
                        </fieldset>
                    </div>
                    <div className="c-veileder__content--cta-area">
                        <button onClick={buttonClickHandler} className="c-knapp c-knapp--cta c-knapp--secondary">{contentResolver(epiContext, 'steg4Knappetekst')}</button>
                    </div>
                </div>
            }
            sporsmalId={props.sporsmalId}
        />
    )
}

interface MapStateToProps {
    epiContext: EpiContext<ForelopigUttalelseSkjemaSideDto>;
    stegState: StegVisning;
}

interface MapDispatchToProps {
    stegVisningSetCollapsed: typeof setCollapsed;
}

export default connect(
    (state: ForelopigUttalelseSkjemaSideAppState, ownProps: Steg4aComponentOwnProps): MapStateToProps => {
        const stegState = state.stegVisning[ownProps.sporsmalId]
            ? state.stegVisning[ownProps.sporsmalId]
            : { id: ownProps.sporsmalId, isCollapsed: false };
        return {
            stegState,
            epiContext: state.epiContext,
        };
    },
    {
        stegVisningSetCollapsed: setCollapsed,
    },
)(Steg4aComponentVisning);